document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('th-footer');
  if (!footer) return;

  footer.addEventListener('locale_change', (e) => {
    document.location.href = `/locales/set?to_locale=${e.detail.value}`;
  });
});
